import React from 'react';
import { media } from 'src/views/theme';
import styled from 'styled-components';
import ArticleCard from '../article-card';
import { ListComponent } from '../builders/listing-builder';
import Pagination from '../pagination';

const Flex = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;

  ${ media.md } {
    flex-wrap: nowrap;
    flex-direction: column;
  }
`;

const BlogList: React.FC<ListComponent> = ({
  totalPages,
  currentPage,
  articles,
}) => (
  <>
    <Flex>
      {articles.edges.map(({ node: { articleSettings: article } }) => (
        <ArticleCard
          key={article.slug}
          article={article}
        />
      ))}
    </Flex>
    <Pagination
      totalPages={totalPages}
      currentPage={currentPage}
      subPath="blog"
    />
  </>
);

export default BlogList;
